import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { createSelector } from '@reduxjs/toolkit';
import { createCurrentSelector } from '@beef/redux';
import { emptyObj } from '@beef/utils';
import { selectHeader, selectHeaderCommonData } from "../../common";
import { ECurrentModalStep } from "../../types";
export var selectMenuData = function selectMenuData(state) {
  return selectHeader(state).menu || emptyObj;
};
export var selectIsMenuModalOpen = function selectIsMenuModalOpen(state) {
  return selectMenuData(state).isMenuModalOpen;
};
export var selectActiveCategory = function selectActiveCategory(state) {
  return selectMenuData(state).activeCategory;
};
export var selectInitialActiveCategory = createSelector(selectHeaderCommonData, function (_ref) {
  var menu = _ref.menu;
  var initialCategory = menu.leftBlock.find(function (item) {
    return item.id === (menu === null || menu === void 0 ? void 0 : menu.initialCategoryId);
  });
  return initialCategory || menu.leftBlock[0];
});
export var selectInitialActiveTab = createSelector(selectHeaderCommonData, selectInitialActiveCategory, function (_ref2, initialCategory) {
  var menu = _ref2.menu;
  var initialTab = initialCategory === null || initialCategory === void 0 ? void 0 : initialCategory.navigationItems.find(function (item) {
    return item.id === (menu === null || menu === void 0 ? void 0 : menu.initialTabId);
  });
  return initialTab || null;
});
export var selectMenuActiveTab = function selectMenuActiveTab(state) {
  return selectMenuData(state).activeTab;
};
export var selectActiveTab = createSelector(selectMenuActiveTab, selectActiveCategory, function (activeTab, activeCategory) {
  var _activeCategory$navig;
  return activeTab || (activeCategory === null || activeCategory === void 0 ? void 0 : (_activeCategory$navig = activeCategory.navigationItems) === null || _activeCategory$navig === void 0 ? void 0 : _activeCategory$navig[0]);
});
export var selectModalStep = function selectModalStep(state) {
  return selectMenuData(state).currentModalStep;
};
export var selectIsModalStepSearch = function selectIsModalStepSearch(state) {
  return selectModalStep(state) === ECurrentModalStep.search;
};
export var selectIsModalStepMenu = function selectIsModalStepMenu(state) {
  return selectModalStep(state) === ECurrentModalStep.menu;
};
export var selectCategories = function selectCategories(state) {
  return selectHeaderCommonData(state).menu.leftBlock;
};
export var selectRightBlockLinks = function selectRightBlockLinks(state) {
  return selectHeaderCommonData(state).menu.rightBlock;
};
export var selectCategoriesLinks = createSelector(selectRightBlockLinks, function (links) {
  return links.filter(function (link) {
    return link.isInMobileMenu;
  });
});
export var selectBottomLinks = createSelector(selectRightBlockLinks, function (links) {
  return links.filter(function (link) {
    return !link.isInMobileMenu;
  });
});
export var selectSocialLinks = function selectSocialLinks(state) {
  return selectHeaderCommonData(state).socialLinks || emptyObj;
};
export var selectStoreLinks = function selectStoreLinks(state) {
  return selectSocialLinks(state).storeLinks;
};
export var selectStoreIcons = function selectStoreIcons(state) {
  return selectSocialLinks(state).storeIcons;
};
export var selectAvailableCategories = createSelector(selectCategories, selectActiveCategory, function (categories, activeCategory) {
  return categories.filter(function (category) {
    return category.title !== (activeCategory === null || activeCategory === void 0 ? void 0 : activeCategory.title);
  });
});
export var selectTabs = createSelector(selectActiveCategory, function (activeCategory) {
  var _activeCategory$navig2, _activeCategory$navig3;
  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    (activeCategory === null || activeCategory === void 0 ? void 0 : (_activeCategory$navig2 = activeCategory.navigationItems) === null || _activeCategory$navig2 === void 0 ? void 0 : _activeCategory$navig2.length) > 1 ? activeCategory === null || activeCategory === void 0 ? void 0 : (_activeCategory$navig3 = activeCategory.navigationItems) === null || _activeCategory$navig3 === void 0 ? void 0 : _activeCategory$navig3.filter(function (item) {
      var _item$navigationItems;
      return (_item$navigationItems = item.navigationItems) === null || _item$navigationItems === void 0 ? void 0 : _item$navigationItems.length;
    }) : null
  );
});
export var selectLinks = createSelector(selectActiveTab, selectActiveCategory, function (activeTab, activeCategory) {
  var _activeCategory$navig4;
  if (!activeTab) return (activeCategory === null || activeCategory === void 0 ? void 0 : (_activeCategory$navig4 = activeCategory.navigationItems[0]) === null || _activeCategory$navig4 === void 0 ? void 0 : _activeCategory$navig4.navigationItems) || [];
  var _ref3 = activeCategory ? activeCategory.navigationItems.filter(function (tab) {
      return tab.id === activeTab.id;
    }) : [],
    _ref4 = _slicedToArray(_ref3, 1),
    currentTab = _ref4[0];
  return currentTab === null || currentTab === void 0 ? void 0 : currentTab.navigationItems;
});
export var selectBanner = createSelector(selectActiveTab, selectActiveCategory, function (activeTab, activeCategory) {
  var _activeCategory$navig5, _activeCategory$navig6, _currentTab$banners;
  if (!activeTab) return (activeCategory === null || activeCategory === void 0 ? void 0 : (_activeCategory$navig5 = activeCategory.navigationItems[0]) === null || _activeCategory$navig5 === void 0 ? void 0 : (_activeCategory$navig6 = _activeCategory$navig5.banners) === null || _activeCategory$navig6 === void 0 ? void 0 : _activeCategory$navig6[0]) || null;
  var _ref5 = activeCategory ? activeCategory.navigationItems.filter(function (tab) {
      return tab.id === activeTab.id;
    }) : [],
    _ref6 = _slicedToArray(_ref5, 1),
    currentTab = _ref6[0];
  return (currentTab === null || currentTab === void 0 ? void 0 : (_currentTab$banners = currentTab.banners) === null || _currentTab$banners === void 0 ? void 0 : _currentTab$banners[0]) || null;
});
var _createCurrentSelecto = createCurrentSelector(selectAvailableCategories, function (item) {
    return item.id;
  }),
  withMenuCategoriesMapper = _createCurrentSelecto.withCurrentProviderMapper,
  selectCurrentCategory = _createCurrentSelecto.selectCurrent;
export { withMenuCategoriesMapper, selectCurrentCategory };
var _createCurrentSelecto2 =
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  createCurrentSelector(selectTabs, function (item) {
    return item.id;
  }),
  withMenuTabMapper = _createCurrentSelecto2.withCurrentProviderMapper,
  selectCurrentTab = _createCurrentSelecto2.selectCurrent;
export { withMenuTabMapper, selectCurrentTab };
export var selectCurrentTabIsActive = createSelector(selectCurrentTab, selectTabs, selectActiveTab, function (currentTab, tabs, activeTab) {
  if (activeTab) return currentTab.title === activeTab.title;
  var currentTabIndex = tabs === null || tabs === void 0 ? void 0 : tabs.findIndex(function (tab) {
    return tab.title === currentTab.title;
  });
  return currentTabIndex === 0;
});
export var selectNavigationHasTitle = createSelector(selectLinks, function (links) {
  return (links === null || links === void 0 ? void 0 : links.filter(function (_ref7) {
    var title = _ref7.title;
    return !!title;
  }).length) > 0;
});
var _createCurrentSelecto3 = createCurrentSelector(selectLinks, function (item) {
    return item.id;
  }),
  withMenuNavigationMapper = _createCurrentSelecto3.withCurrentProviderMapper,
  selectCurrentNavigation = _createCurrentSelecto3.selectCurrent;
export { withMenuNavigationMapper, selectCurrentNavigation };
var _createCurrentSelecto4 = createCurrentSelector(selectBottomLinks, function (item) {
    return item.title;
  }),
  withMenuFooterLinks = _createCurrentSelecto4.withCurrentProviderMapper,
  selectCurrentFooterLink = _createCurrentSelecto4.selectCurrent;
export { withMenuFooterLinks, selectCurrentFooterLink };